import {office} from '../../../packages/content-client/src'

/** A native acknowledgment is not a storage receipt. ExtendedData binds this
 * save intent to the actual WOPI transaction, including an unchanged save. */
export async function saveToForge(fileId:string,send:(message:object)=>void,current:()=>boolean=()=>true){
 const receipt=await office<{request_id:string}>(`/files/${fileId}/save-requests`,{method:'POST'})
 const request=()=>send({MessageId:'Action_Save',Values:{Notify:true,DontTerminateEdit:false,DontSaveIfUnmodified:false,ExtendedData:'folio-save-v1:'+receipt.request_id}})
 if(!current())throw Error('Save cancelled; the editor remains open.')
 request()
 for(let i=0;i<80;i++){
  if(!current())throw Error('Save cancelled; the editor remains open.')
  const state=await office<{state:string;publication_state:string|null;version:number|null;content_hash:string|null;forge_commit:string|null}>(`/files/${fileId}/save-requests/${receipt.request_id}`)
  if(!current())throw Error('Save cancelled; the editor remains open.')
  if(state.state==='committed'&&state.publication_state==='ready'&&state.version&&state.content_hash&&state.forge_commit)return state
  // A manual request can arrive while the native autosave is already busy.
  // Reusing this receipt is idempotent and cannot accept a different body.
  if(state.state==='pending'&&(i===6||i===18))request()
  await new Promise<void>(resolve=>setTimeout(resolve,500))
 }
 throw Error('Saving to Forge is not confirmed. Keep this editor open and retry. Your editor has not been closed.')
}
